import React from 'react';
import { Calendar, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PlanningSSI = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/dashboard/ssi')}
          className="p-2 hover:bg-gray-100 rounded-lg"
        >
          <ArrowLeft className="h-6 w-6" />
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <Calendar className="h-8 w-8 text-purple-600" />
            Planning SSI
          </h1>
          <p className="text-gray-600 mt-1">Planification des vérifications périodiques</p>
        </div>
      </div>

      <div className="bg-purple-50 border border-purple-200 rounded-lg p-8 text-center">
        <Calendar className="h-16 w-16 mx-auto mb-4 text-purple-500" />
        <h2 className="text-2xl font-bold text-purple-900 mb-2">Planning des Vérifications SSI</h2>
        <p className="text-purple-700 mb-4">
          Planification automatique des vérifications réglementaires selon périodicités
        </p>
        <div className="text-sm text-purple-600 space-y-2">
          <p>✅ Calendrier des vérifications à venir</p>
          <p>✅ Affectation des techniciens</p>
          <p>✅ Rappels automatiques</p>
          <p>✅ Génération planning optimisé</p>
          <p>✅ Export PDF/Excel</p>
        </div>
      </div>
    </div>
  );
};

export default PlanningSSI;
